import { render, staticRenderFns } from "./AppPhotoGalleryItem.vue?vue&type=template&id=06a6f0b1&scoped=true&"
import script from "./AppPhotoGalleryItem.vue?vue&type=script&lang=js&"
export * from "./AppPhotoGalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./AppPhotoGalleryItem.vue?vue&type=style&index=0&id=06a6f0b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6f0b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VImg,VSheet})
